import request from "./api.js"

const baseUrl = 'https://admin.huimiaokeji.com/appApi'; // 设置环境接口的域名
// const baseUrl = 'http://localhost:8080/appApi';

export function getUrlParams(url, data) {
	if (data) {
		let u = "?"
		for (let key in data) {  
		  if (data.hasOwnProperty(key) && data[key]) {
			 if (u != "?") {
				 u += "&";
			 }
			 u += key + "=" + data[key];
		  }
		}
		return url += u;
	}
	return url;
}
 
export function getArticleList(data) {
    return request({
        url: getUrlParams(baseUrl + `/bus/free/articleList`, data),
        method: 'get',
        timeout: 20000,
    })
}

export function getArticleDetail(data) {
    return request({
        url: getUrlParams(baseUrl + `/bus/free/articleDetail`, data),
        method: 'get',
        timeout: 20000,
    })
}










// WEBPACK FOOTER //
// ./src/api/index.js